import { render, staticRenderFns } from "./NOSLoading.vue?vue&type=template&id=11de6b8a"
import script from "./NOSLoading.vue?vue&type=script&lang=js"
export * from "./NOSLoading.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/devopsfs01/workspace/dev-rca-mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11de6b8a')) {
      api.createRecord('11de6b8a', component.options)
    } else {
      api.reload('11de6b8a', component.options)
    }
    module.hot.accept("./NOSLoading.vue?vue&type=template&id=11de6b8a", function () {
      api.rerender('11de6b8a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/pluginFree/NOSLoading.vue"
export default component.exports